import React from 'react';

import { appMethod as app } from '@utils/app';
import './OpenLocation.less';

export class OpenLocation extends React.Component {
  constructor(props) {
    super(props);
    this.options = this.props.options;
    this.mapInstance = null;
    this.marker = null;

  }

  componentDidMount() {
    if(!this.options || !this.options.latitude || !this.options.longitude){
      app.showToast({
        title: '经纬度是必填参数'
      })
      console.error('openLocation接口，经纬度是必填参数');
      return;
    }

    // this.mapInstance = new qq.maps.Map(document.getElementById("open-location-map") , {
    //   zoom: 15,
    //   zoomControl: false,
    //   panControl: false,
    //   mapTypeControl: false
    // });

    // let latlng = new qq.maps.LatLng(this.options.latitude, this.options.longitude);
    // this.mapInstance.panTo(latlng);
    // this.setMarker(latlng);
    // this.locationIcon();
    // this.backIcon();
  }

  // 添加定位自定义控件
  locationIcon(){
    let locatioControl = document.createElement("div");
    locatioControl.style.cssText = 'width:35px;height:35px;border:1px solid #e9e9e9;border-radius: 20px;margin-right:10px;text-align: center;line-height: 35px;font-size: 20px;color: #07c160;background-color:#ffffff;';
    locatioControl.innerHTML = '<span class="icon-moon icon-relocate" style="line-height: 35px;"><span>';
    locatioControl.index = 3;

    this.mapInstance.controls[qq.maps.ControlPosition.RIGHT_BOTTOM].push(locatioControl);

    qq.maps.event.addListener(locatioControl, "click", () => {
      this.getLocation();
    });
  }

  // 添加返回按钮
  backIcon(){
    let backControl = document.createElement("div");
    backControl.style.cssText = 'width:30px;height:30px;border-radius: 2px;margin:10px;text-align: center;line-height: 30px;font-size: 18px;color: #ffffff;background-color:rgba(0,0,0,.5);';
    backControl.innerHTML = '<span class="icon-moon icon-leftarrow" style="line-height: 30px;"><span>';
    backControl.index = 3;

    this.mapInstance.controls[qq.maps.ControlPosition.LEFT_TOP].push(backControl);

    qq.maps.event.addListener(backControl, "click", () => {
      ReactDOM.unmountComponentAtNode(document.getElementById('popup'));
    });
  }

  // 获取定位
  getLocation(){
    app.getLocation({
      success: (res) => {
        let latlng = new qq.maps.LatLng(res.latitude, res.longitude);
        this.mapInstance.panTo(latlng);
        this.setMarker(latlng);
      },
      fail: (res) => {
        // 定位失败，用ip获取城市定位
        let citylocation = new qq.maps.CityService({
          complete : (result) =>{
            this.mapInstance.panTo(result.detail.latLng);
            this.setMarker(result.detail.latLng);
          },
          error: () => {
            app.showToast({
              title: '定位失败'
            })
          }
        });
        citylocation.searchLocalCity();
      }
    });
  }

  // 设置标记
  setMarker(latlng){
    this.marker && this.marker.setMap(null);
    this.marker = new qq.maps.Marker({
        map: this.mapInstance,
        position: latlng
    });
  }
  
  render() {
    return (
      <div className="common-api open-location">
        <div className="open-location-map" id="open-location-map"></div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/common/open-location/OpenLocation.jsx